import { BCKSUploadNapzaPage } from 'app/BCKSPage/Invitation/napza'

const BCKSUploadNapzaIndexPage = () => {
  return <BCKSUploadNapzaPage />
}

// eslint-disable-next-line react/display-name
BCKSUploadNapzaIndexPage.Layout = ({ children }) => children

export default BCKSUploadNapzaIndexPage
